import React, { useState } from "react";
import { LogIn, Search } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Avatar } from "../components/pm/bits";

export const EP_LOGO =
  "https://images.squarespace-cdn.com/content/v1/60bf46855b35197d90ad4d6a/2fe6a5e1-3577-4344-a25f-eb0a17310d8b/EPG50+-+landscape+over+red+background%404x.png?format=1500w";

export default function Login() {
  const { team, loading, login } = useApp();
  const [q, setQ] = useState("");
  const list = team.filter((m) => `${m.name} ${m.role}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="login-bg relative flex min-h-screen items-center justify-center overflow-hidden px-4 py-10">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-[#b8975a]" />
      <div className="relative w-full max-w-3xl animate-fade-in-up">
        <div className="mb-8 flex flex-col items-center text-center">
          <img alt="EP Group" className="h-10 w-auto" src={EP_LOGO} />
          <h1 className="mt-6 text-2xl font-bold text-white" data-testid="login-title">
            Project Management System
          </h1>
          <p className="mt-1 text-sm text-[#b9c9bf]">
            Select your profile to sign in · <span className="font-harrods text-base font-bold italic text-[#d6b77a]">Harrods</span> programme
          </p>
        </div>

        <div className="relative mx-auto mb-5 max-w-sm">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#7f998a]" />
          <input
            data-testid="login-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Find your profile..."
            className="h-10 w-full rounded-lg border border-white/10 bg-white/5 pl-9 pr-3 text-sm text-white placeholder:text-[#7f998a] focus:border-[#b8975a] focus:outline-none"
          />
        </div>

        {loading ? (
          <p className="text-center text-sm text-[#b9c9bf]">Loading live data...</p>
        ) : (
          <div className="space-y-7">
            {["EP Group", "Harrods"].map((org) => {
              const members = list.filter((m) => (m.org || "EP Group") === org);
              if (!members.length) return null;
              return (
                <div key={org} data-testid={`login-group-${org.replace(" ", "-").toLowerCase()}`}>
                  <p className="mb-3 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.18em] text-[#d6b77a]">
                    {org === "Harrods" ? "Harrods contacts" : "EP Group delivery team"}
                    <span className="h-px flex-1 bg-gradient-to-r from-[#b8975a]/40 to-transparent" />
                  </p>
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                    {members.map((m, i) => (
                      <button
                        key={m.id}
                        data-testid={`login-profile-${m.id}`}
                        onClick={() => login(m)}
                        style={{ animationDelay: `${i * 25}ms` }}
                        className={`group flex animate-fade-in-up items-center gap-3 rounded-xl border p-4 text-left transition-colors hover:border-[#b8975a] hover:bg-[#164434] ${
                          org === "Harrods" ? "border-[#b8975a]/30 bg-[#163d2f]" : "border-white/10 bg-[#11382b]"
                        }`}
                      >
                        <Avatar person={m} size={44} className="ring-0" />
                        <div className="min-w-0 flex-1">
                          <p className="truncate text-sm font-semibold text-white">{m.name}</p>
                          <p className="truncate text-xs text-[#9fb3a7]">{m.role}</p>
                        </div>
                        <LogIn className="h-4 w-4 text-[#6f8a7b] transition-colors group-hover:text-[#d6b77a]" />
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <p className="mt-8 text-center text-xs text-[#7f998a]">
          Demo sign-in — no password required. Each profile sees their own projects, tasks &amp; notifications.
        </p>
      </div>
    </div>
  );
}
